import styles from './Loader.module.scss';
import cn from 'classnames';

type LoaderProps = {
  fullScreen?: boolean;
  className?: string;
};

export function Loader({ fullScreen = false, className }: LoaderProps) {
  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.fullScreen]: fullScreen,
    },
    className,
  );

  return (
    <div className={wrapperClassName}>
      <img
        loading="lazy"
        className={styles.loader}
        alt="loader"
        src="/svg/loader.svg"
      />
    </div>
  );
}
